module.exports = __webpack_public_path__ + "img/shanchu-zhihui@3x.85e17eb2.svg";